import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class MonasteryAbandoned2PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.MONASTERY_ABANDONED2;
}

export default MonasteryAbandoned2PoiTileEntity;
